import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useState, useEffect } from 'react';
import { GlobalButton } from '@/components';
import {
  isGpsTrackerMockEnabled,
  toggleGpsTrackerMock,
} from '../services/gpsTrackerMock.service';

const MockModeToggle = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(isGpsTrackerMockEnabled());
  }, []);

  const handleToggle = () => {
    const newState = toggleGpsTrackerMock();
    setIsEnabled(newState);
  };

  return (
    <GlobalButton
      variant={
        isEnabled
          ? GlobalButtonVariant.primaryButton
          : GlobalButtonVariant.secondaryButton
      }
      action={handleToggle}
    >
      {isEnabled ? 'Desactivar modo de prueba' : 'Activar modo de prueba'}
    </GlobalButton>
  );
};

export default MockModeToggle;
